import type { ReactNode } from 'react';
import { cn } from '../utils/cn';

interface FormSectionProps {
  title: string;
  description?: string;
  children: ReactNode;
  className?: string;
}

export default function FormSection({ title, description, children, className }: FormSectionProps) {
  return (
    <div className={cn('rounded-xl border border-border bg-surface-card p-5', className)}>
      <div className="mb-4 border-b border-border pb-3">
        <h3 className="text-sm font-semibold text-content-primary">{title}</h3>
        {description && <p className="text-xs text-content-muted mt-0.5">{description}</p>}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {children}
      </div>
    </div>
  );
}
